module.exports = __webpack_public_path__ + "static/media/infoImage-04.2b472abd.png";